import { useContext, useEffect, useState } from 'react';
import { AddIcon, DeleteCrossIcon } from '../../../../assets/icons/controls/controls';
import { PRODUCT_FORM_TYPE_BOOLEAN, PRODUCT_FORM_TYPE_NUMBER, PRODUCT_FORM_TYPE_TEXT } from '../../../../assets/utils/constants';
import { UserContext } from '../../../../assets/contexts/userContext';
import {
    getParameterSuggestions,
    loadParameterKeySuggestions,
    loadParameterValueSuggestions,
    normalizeSuggestionKey,
} from '../../../../assets/utils/parameterValueSuggestions';
import PlatformInput from '../../PlatformInput/PlatformInput';
import './ProductFormParameters.css';

const DEFAULT_OPTIONS_TYPES = [
    PRODUCT_FORM_TYPE_NUMBER,
    PRODUCT_FORM_TYPE_TEXT,
    PRODUCT_FORM_TYPE_BOOLEAN,
]

function ProductFormParameters({
    handleChange,
    product,
    error,
    readOnly,
    autoParameterState,
    onAutoFillParameters,
    onAddAutoParameter,
}) {
    const { user } = useContext(UserContext);
    const missingParameters = autoParameterState?.missingDefinitions || [];
    const hasMissingParameters = missingParameters.length > 0;
    const [parameterSuggestionsMap, setParameterSuggestionsMap] = useState(new Map());
    const [parameterKeySuggestions, setParameterKeySuggestions] = useState([]);
    const missingTitle = hasMissingParameters
        ? missingParameters.length === 1
            ? 'Не хватает 1 параметра'
            : `Не хватает ${missingParameters.length} параметров`
        : 'Основные параметры на месте';

    useEffect(() => {
        const shopId = user?.default_shop?._id;

        if (!shopId) return;

        loadParameterValueSuggestions(shopId).then((suggestionsMap) => {
            setParameterSuggestionsMap(suggestionsMap);
        });

        loadParameterKeySuggestions(shopId).then((suggestions) => {
            setParameterKeySuggestions(suggestions);
        });
    }, [user]);

    function getAvailableTitleSuggestions(currentParameterId) {
        const existingKeys = new Set(
            product.parameters
                .filter((item) => item._id !== currentParameterId)
                .map((item) => normalizeSuggestionKey(item.title))
        );

        return parameterKeySuggestions.filter(
            (item) => !existingKeys.has(normalizeSuggestionKey(item))
        );
    }

    return (
        <div className='product-form__parameters'>
            {autoParameterState?.totalCount > 0 && !readOnly ? (
                <div className='product-form-parameters__actions'>
                    <div className='product-form-parameters__autofill-box'>
                        <div className={`product-form-parameters__hint ${hasMissingParameters ? '' : 'product-form-parameters__hint_complete'}`}>
                            <div className='product-form-parameters__hint-top'>
                                <div className='product-form-parameters__hint-head'>
                                    <p className='product-form-parameters__hint-title'>
                                        {missingTitle}
                                    </p>
                                </div>
                                {hasMissingParameters ? (
                                    <button
                                        className='product-form-parameters__autofill-btn'
                                        type='button'
                                        onClick={onAutoFillParameters}
                                    >
                                        {`Добавить все ${missingParameters.length}`}
                                    </button>
                                ) : null}
                            </div>
                            {hasMissingParameters ? (
                                <div className='product-form-parameters__hint-body'>
                                    <p className='product-form-parameters__section-title'>
                                        Добавить по одному
                                    </p>
                                    <div className='product-form-parameters__chips'>
                                        {missingParameters.map((parameter) => (
                                            <button
                                                className='product-form-parameters__chip'
                                                type='button'
                                                key={parameter.name}
                                                onClick={() => onAddAutoParameter(parameter.name)}
                                            >
                                                {parameter.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : null}
            <div className='product-form__parameter'>
                <PlatformInput
                    value={'Артикул'}
                    placeholder={'Артикул'}
                    label={'Параметр'}
                    // hint={'Видно только вам'}
                    readOnly={true}
                    isSelect={false}
                    //selected_text_value={'Артикул'}
                    // handleChange={handleChange}
                    // name={'article'}
                    maxLength={100}
                    isNoChange={true}
                    showFilledState={false}
                >
                </PlatformInput>
                <PlatformInput
                    value={'Текст'}
                    placeholder={'Текст'}
                    label={'Тип'}
                    // hint={'Видно только вам'}
                    readOnly={true}
                    isSelect={false}
                    // selected_text_value={'Текст'}
                    maxLength={100}
                    isNoChange={true}
                    showFilledState={false}
                >
                </PlatformInput>
                <PlatformInput
                    value={product.article}
                    placeholder={''}
                    label={'Значение'}
                    // hint={'Видно только вам'}
                    handleChange={handleChange}
                    name={'article'}
                    maxLength={100}
                    readOnly={readOnly}
                    showFilledState={true}
                ></PlatformInput>
            </div>
            {product.parameters.map((parameter, parameter_index) => (
                <div className='product-form__parameter' key={`product-form__parameter-${parameter_index}`}>
                    <PlatformInput
                        value={parameter.title}
                        placeholder={''}
                        label={''}
                        readOnly={readOnly}
                        // hint={'Видно только вам'}
                        handleChange={(e) => {
                            handleChange({
                                target: {
                                    value: e.target.value,
                                    name: 'parameter-title',
                                    parameter_id: parameter._id,
                                    parameter_key: 'title',
                                }
                            })
                        }}
                        // name={'article'}
                        maxLength={100}
                        show_eror_color_only={true}
                        showFilledState={false}
                        suggestions={getAvailableTitleSuggestions(parameter._id)}
                        onSuggestionSelect={(suggestedValue) => {
                            handleChange({
                                target: {
                                    value: suggestedValue,
                                    name: 'parameter-title',
                                    parameter_id: parameter._id,
                                    parameter_key: 'title',
                                }
                            })
                        }}
                        error={
                            error && error[parameter_index].title.errorMessage
                                ? error[parameter_index].title.errorMessage
                                : ""
                        }
                    >
                    </PlatformInput>
                    <PlatformInput
                        value={parameter.type}
                        placeholder={''}
                        label={''}
                        readOnly={readOnly}
                        // hint={'Видно только вам'}
                        isSelect={true}
                        selected_text_value={parameter.type.title}
                        maxLength={100}
                        handleChange={(e) => {
                            handleChange({
                                target: {
                                    value: e.target.value,
                                    name: 'parameter-type',
                                    parameter_id: parameter._id,
                                    parameter_key: 'type',
                                }
                            })
                        }}
                        selectList={DEFAULT_OPTIONS_TYPES}
                        selectDifferenceKey={'type'}
                        selectTextValueKey={'title'}
                        name={'parameter-type'}
                        showFilledState={false}
                    >
                    </PlatformInput>

                    {parameter.type.type === PRODUCT_FORM_TYPE_BOOLEAN.type ?
                        <PlatformInput
                            readOnly={readOnly}
                            value={parameter.value}
                            placeholder={''}
                            label={''}
                            boolean_values={{
                                true: {
                                    title: 'Да',
                                },
                                false: {
                                    title: 'Нет',
                                },
                            }}
                            isBooleanSelector={true}
                            // hint={'Видно только вам'}
                            handleChange={(e) => {
                                handleChange({
                                    target: {
                                        value: e.target.value,
                                        name: 'parameter-value',
                                        parameter_id: parameter._id,
                                        parameter_key: 'value',
                                        parameter_type: parameter.type,
                                    }
                                })
                            }}
                            name={'parameter-value'}
                            maxLength={100}
                            showFilledState={true}
                        ></PlatformInput>
                        :
                        <PlatformInput
                            readOnly={readOnly}
                            value={parameter.value}
                            placeholder={''}
                            label={''}
                            // hint={'Видно только вам'}
                            handleChange={(e) => {
                                handleChange({
                                    target: {
                                        value: e.target.value,
                                        name: 'parameter-value',
                                        parameter_id: parameter._id,
                                        parameter_key: 'value',
                                        parameter_type: parameter.type,
                                    }
                                })
                            }}
                            name={'parameter-value'}
                            maxLength={100}
                            show_eror_color_only={true}
                            showFilledState={true}
                            suggestions={
                                parameter.type.type === PRODUCT_FORM_TYPE_TEXT.type
                                    ? getParameterSuggestions(parameterSuggestionsMap, parameter.title)
                                    : []
                            }
                            onSuggestionSelect={
                                parameter.type.type === PRODUCT_FORM_TYPE_TEXT.type
                                    ? (suggestedValue) => {
                                        handleChange({
                                            target: {
                                                value: suggestedValue,
                                                name: 'parameter-value',
                                                parameter_id: parameter._id,
                                                parameter_key: 'value',
                                                parameter_type: parameter.type,
                                            }
                                        })
                                    }
                                    : null
                            }
                            error={
                                error && error[parameter_index].value.errorMessage
                                    ? error[parameter_index].value.errorMessage
                                    : ""
                            }
                        ></PlatformInput>
                    }

                    <button className='product-form__option-value-control' type='button' onClick={() => {
                        if (readOnly) return
                        handleChange({
                            target: {
                                value: null,
                                name: 'parameter-delete',
                                parameter_id: parameter._id,
                            }
                        })
                    }}>
                        <DeleteCrossIcon
                            mainClassName={'product-form__option-value-control-icon'}
                            fillClassName={'product-form__option-value-control-icon-fill'}
                        />
                    </button>
                </div>
            ))}
            {product.parameters.length < 20 && !readOnly ?
                <button className='product-form__btn' type='button' onClick={() => {
                    handleChange({
                        target: {
                            value: null,
                            name: 'add-parameter',
                        }
                    })
                }}>
                    <AddIcon
                        mainClassName={'product-form__btn-icon'}
                        fillClassName={'product-form__btn-icon-fill'}
                    />
                    Добавить параметр
                </button>
                : null}
        </div>
    );
}

export default ProductFormParameters
